const Form049EN = {
    stepName: {
        statement: "Important Notes",
        application: "Application Details",
        confirmation: "Confirmation",
    },
    errorMsg: {
        date: {
            afterThisDate:
                "Please select a date after the First Day of Appointment",
        },
        needOne:
            "must fill either 'Name of Kindergarten' or 'Name of Child Care Centre'",
        leastOneNo: "Please fill in at least one number.",
    },
    serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],
    noteTitle1: "<u>Purpose of Collection</u>",
    noteTitle3: "<u>Classes of Transferees</u>",
    noteTitle4: "<u>Access to Personal Data</u>",
    notes: [
        "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",
        "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to  <a href='mailto:jokc@edb.gov.hk'>jokc@edb.gov.hk</a>.",
    ],
    notes1: [
        "Activities relating to the processing, authentication and counter-checking of the Staff Changes of Kindergarten cum Child Care Centre;",
        "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        "Activities relating to compilation of statistics, research and Government publications; and",
        "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant / Subsidized Schools Provident Fund Rules); and the Codes of Aid, the Child Care Services Ordinance (Cap.243) and its subsidiary legislation (i.e., the Child Care Services Regulations (Cap 243 A) )",
    ],
    notes3: [
        "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
        "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        "where you have given your prescribed consent to such disclosure; and",
        "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
    ],
    label: {
        note: "Important Notes",
        p_title: "Personal Information Collection Statement",
        basicInfor: "Name of Kindergarten and Child Care Centre",
        noteItemOne:
            "In accordance with S39(2) of Education Ordinance, where the principal ceases to perform the duties of the principal and where any teacher commences / ceases to teach at school occurs, the ",
        boldTextOne: "supervisor",
        noteItemTwo:
            " shall inform the Permanent Secretary for Education in writing thereof ",
        boldTextTwo: "within 1 month.",
        noteItemThree:
            " In accordance with R7(2) of the Child Care Services Regulations, where any change occurs in the supervisor / child care worker, the ",
        boldTextThree: "operator / supervisor",
        noteItemFour:
            " shall inform the Director of Social Welfare in writing thereof ",
        boldTextFour: "within 14 days",
        noteItemSix: " of the occurrence.",
        statement: "Statement",
        certify:
            "I have read, understood and agreed to the above terms and conditions.",
        smart: "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        kindergarten: "Name of Kindergarten",
        childCareName: "Name of Child Care Centre",
        nameEnglish: "Name of Teacher/Child Care Worker (in English)",
        nameChinese: "Name of Teacher/Child Care Worker (in Chinese)",
        qualification: "Qualification",
        rtNo: "RT No.",
        validPTNo: "Valid PT No.",
        progress: "Application in progress",
        cCCSNo: "CCC/S No.",
        cCCWNo: "CCC/W No.",
        workingHours: "Working Hours",
        firstDate: "First Day of Appointment in this KG-cum-CCC",
        position: "Have you left the position",
        lastDate: "Last date of employment in this KG-cum-CCC",
        responsible: "Class Responsible for",
        training: "First Aid Training Received",
        certificateNo: "Valid First Aid Certificate No. (if any)",
        effectiveDate: "First Aid Certificate No. valid on",
        expiryDate: "First Aid Certificate No. expiry on",
        submit: "I want to submit this application form",
        attachment: "Attachment Upload",
        rtptNo: "RT No./Valid PT No.",
        cCCNo: "CCC/S No./CCC/W No.",
        registrationCert: "Attachment",
        firstAidCert:
            "Valid First Aid Certificates of Teacher/Child Care Staff",
        attachmentTitle:
            "Unless already submitted, please attach all the certified true copies of registration certificates and valid first aid certificates of teacher / child care staff for record",
        supervisorName: "Name of Supervisor",
    },
    no: {
        rtNo: "R",
        validPTNo: "P",
    },
    cCCNo: {
        cCCSNo: "CCC/S",
        cCCWNo: "CCC/W",
    },
    noteValue: {
        note1: "「BEd(ECE)」: QKTs/CCWs with a bachelor degree in Early Childhood Education or equivalent ",
        note2: "「C(ECE)」: QKTs/CCWs with a Certificate in Early Childhood Education or equivalent ",
        note3: "「QKT」: Qualified Kindergarten Teachers",
        note4: "「CCW」: Child Care Workers",
        note5: "「Pursuing C(ECE)」: QKTs/CCWs or teaching staff with RT/valid PT No. pursuing a Certificate in Early Childhood Education or equivalent",
    },
    workingHoursValue: {
        "AM+PM": "AM+PM",
        AM: "AM",
        PM: "PM",
    },
    whetherValue: {
        Y: "Yes",
        N: "No",
    },
    qualificationValue: {
        "BEd(ECE)": "BEd(ECE)",
        "C(ECE)": "C(ECE)",
        QKT: "QKT",
        CCW: "CCW",
        "Pursuing C(ECE)": "Pursuing C(ECE)",
    },
    responsibleValue: {
        kg: "KG",
        ccc: "CCC",
    },
};
export default Form049EN;
